/**
 * @param {string} key
 * @param {string} lang
 * @return {string}
 */
export function translate(key, lang = "en") {
    return window['Translations'].translate(key, lang.toLowerCase());
}